import React from 'react'
import SideNav from '../side-nav'
import {
  useEntities,
  useIncludes,
  useMeta,
  useExperiences,
} from '@uswitch/ev-utils/lib/context/selectors'
import { pageForUrlEntity } from '../../../utils/url'

const getTitleAndUrl = (link, includes, homePath, experiences) => {
  // get whole link entity
  const entity = includes[link?.sys?.id ?? '']
  const typeId = entity?.sys?.contentTypeId

  let linkTitle
  let linkUrl

  if (typeId === 'url') {
    // the entity type is URL
    const url = entity?.fields.url
    linkUrl = url ? (url[0] === '/' ? url : `${homePath}/${url}`) : ''

    // dereference page from url taking into account experiences
    const pageLink = pageForUrlEntity(entity, experiences)
    const pageEntity = includes[pageLink?.sys?.id ?? '']
    linkTitle = pageEntity?.fields?.title
  } else if (entity?.fields?.urlRef) {
    // the entity type is LinkListItem with URL reference
    linkTitle = entity?.fields.title

    // dereference url entity from URL field of list item
    const urlEntity = includes[entity.fields.urlRef?.sys?.id]
    const url = urlEntity?.fields.url
    linkUrl = url ? (url[0] === '/' ? url : `${homePath}/${url}`) : ''
  } else {
    // the entity type is LinkListItem with URL string
    linkTitle = entity?.fields.title
    linkUrl = entity?.fields.url
  }

  return { title: linkTitle, url: linkUrl }
}

export default ({ linkLists = [], ...props }) => {
  const includes = useIncludes()
  const homePath = useMeta(['breadcrumbs', 'homePath'], '')
  const experiences = useExperiences()
  const linkListEntities = useEntities(linkLists)

  const linkListWithLinks = linkListEntities.map(linkGroup => ({
    ...linkGroup,
    links: linkGroup.links
      .map(link => {
        const titleAndUrl = getTitleAndUrl(link, includes, homePath, experiences)
        return {
          text: titleAndUrl.title ?? titleAndUrl.url,
          url: titleAndUrl.url,
        }
      })
      .filter(link => link.url),
  }))

  return <SideNav {...props} additionalLinks={linkListWithLinks} />
}
